function isNonNegativeCount(value) {
  return Number.isFinite(value) && value >= 0;
}

/** Server-marked count from markAllAsRead; fall back to loaded unread ids. */
export default function markedCountFromMarkAllResponse(data, loadedCount = 0) {
  const candidate = data?.modifiedCount ?? data?.nModified ?? data?.result?.nModified;
  if (isNonNegativeCount(candidate)) {
    return candidate;
  }

  return loadedCount;
}
